import React from 'react';
import styled from 'styled-components';

// images
import LoaderSvg from 'assets/pics/icons/loader.svg';

const LoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

const Loader = styled.i`
  background-image: url(${LoaderSvg});
  background-repeat: no-repeat;
  background-size: 100% 100%;
  width: 3.7em;
  height: 3.7em;
`;

const LoadingSpinner = () => (
  <LoaderContainer>
    <Loader />
  </LoaderContainer>
);

export default LoadingSpinner;
